import { render, staticRenderFns } from "./OldResultsPage2025.vue?vue&type=template&id=4a1e4d7a"
import script from "./OldResultsPage2025.vue?vue&type=script&lang=js"
export * from "./OldResultsPage2025.vue?vue&type=script&lang=js"
import style0 from "./OldResultsPage2025.vue?vue&type=style&index=0&id=4a1e4d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports